import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import styled from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UICardSection from 'UIComponents/card/UICardSection';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import { WHY_GO_HUBSPOT_CARD } from '../../../constants/tracking/Locations';
import { ProductLineToColor } from '../../../constants/whyGoHubSpotSection/ProductLineToColor';
import { usePageParams } from '../../../hooks/usePageParams';
import { borderStyle } from '../FreeToolsSharedComponents';
const HeaderSection = styled.div.withConfig({
  displayName: "ProductLineTile__HeaderSection",
  componentId: "jr6qoj-0"
})(["background-color:", " !important;padding:14px 0;"], ({
  productLine
}) => ProductLineToColor[productLine]);
const HeaderTextContainer = styled.h3.withConfig({
  displayName: "ProductLineTile__HeaderTextContainer",
  componentId: "jr6qoj-1"
})(["font-size:1.5rem;color:", ";margin:0;"], OLAF);
const PrimaryTextContainer = styled.div.withConfig({
  displayName: "ProductLineTile__PrimaryTextContainer",
  componentId: "jr6qoj-2"
})(["font-weight:500;margin-bottom:20px;"]);
const Link = styled(UIRouterLink).withConfig({
  displayName: "ProductLineTile__Link",
  componentId: "jr6qoj-3"
})([":hover{text-decoration:none;}"]);
const LinkMessage = styled(FormattedMessage).withConfig({
  displayName: "ProductLineTile__LinkMessage",
  componentId: "jr6qoj-4"
})([":hover{text-decoration:underline !important;}"]);

const ProductLineTile = ({
  productLine,
  commonStyles
}) => {
  const {
    tab
  } = usePageParams();
  const hasTabbedPage = productLine !== COMMERCE;
  const path = `/${productLine.toLowerCase()}${tab && hasTabbedPage ? `/${tab}` : ''}`;

  const handleExploreClick = () => {
    getUsageTracker().track('internalLinkClick', {
      name: 'explore-link',
      url: path,
      trackingSource: WHY_GO_HUBSPOT_CARD
    });
    window.scrollTo(0, 0);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HeaderSection, {
      style: Object.assign({}, commonStyles, {
        gridRowStart: 1,
        height: '60px'
      }),
      productLine: productLine,
      children: /*#__PURE__*/_jsx(HeaderTextContainer, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `whyGoHubSpot.${productLine}.title`
        })
      })
    }), /*#__PURE__*/_jsx(UICardSection, {
      style: Object.assign({}, commonStyles, {
        gridRowStart: 2,
        paddingTop: '20px'
      }),
      children: /*#__PURE__*/_jsx(PrimaryTextContainer, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `whyGoHubSpot.${productLine}.primary`
        })
      })
    }), /*#__PURE__*/_jsx(UICardSection, {
      style: Object.assign({}, commonStyles, {
        gridRowStart: 3
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `whyGoHubSpot.${productLine}.subCopy`
      })
    }), /*#__PURE__*/_jsx(UICardSection, {
      style: Object.assign({}, commonStyles, {
        gridRowStart: 4,
        textAlign: 'left',
        borderBottom: borderStyle
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: createToObject(path),
        onClick: handleExploreClick,
        children: /*#__PURE__*/_jsxs(UIFlex, {
          justify: "center",
          children: [/*#__PURE__*/_jsx(LinkMessage, {
            message: `whyGoHubSpot.${productLine}.explore`
          }), /*#__PURE__*/_jsx(UIIcon, {
            name: "next",
            size: "xs",
            className: "p-left-6"
          })]
        })
      })
    })]
  });
};

export default ProductLineTile;